export default __webpack_public_path__ + "static/media/aboutHz.9b7a89b0.jpg";